import { PERMISSIONS } from "@/constants/permissions"
import { useGuardedMutation } from "@/hooks/useGuardedMutation"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { apiClientV2 } from "../../../services/api/apiClient"
import { toastApiError } from "./apiError"

// The address suppliers send to / receive automated inquiries from. Only the

const BASE = "/material-compliance/supplier-inquiries/settings/email-sender"

export interface EmailSenderIdentity {
  slug: string | null
  domain: string
  fullAddress: string | null
  isSet: boolean
}

const QUERY_KEY = ["mc", "inquiries", "email-sender"]

export function useEmailSenderIdentity(enabled = true) {
  return useQuery<EmailSenderIdentity>({
    queryKey: QUERY_KEY,
    queryFn: () =>
      apiClientV2.get<EmailSenderIdentity>(BASE).then((r) => r.data),
    enabled,
  })
}

export function useUpdateEmailSenderSlug() {
  const queryClient = useQueryClient()
  const { translate } = useTranslation()
  const mutation = useMutation({
    mutationFn: (slug: string) =>
      apiClientV2.put<EmailSenderIdentity>(BASE, { slug }).then((r) => r.data),
    onSuccess: (next) => {
      queryClient.setQueryData(QUERY_KEY, next)
    },
    onError: (error) => {
      toastApiError(error, translate, "MC_API_ERROR_GENERIC")
    },
  })
  return useGuardedMutation(mutation, PERMISSIONS.MC_INQUIRIES_SEND)
}
